module.exports = __webpack_public_path__ + "media/img/pages/profile/ckw ger 5-b0d2812ba4c16c6ace0c47a4240c0e97.jpg";